import { LITE_ROLE_NAME } from './builtInRoles'

/**
 * Whether the role's membership can be edited at all.
 *
 * Every enabled user belongs to Lite whether or not a row says so, and leaves it as soon as they
 * are given any other role, so its membership is a consequence rather than something to set. The
 * legacy screen hid add and remove for it on the same grounds.
 *
 * Whether a role's *permissions* may be edited is not decided here: the server answers that on
 * the role itself, as `permissionsEditable`.
 */
export function isMembershipEditable(roleName: string) {
  return roleName !== LITE_ROLE_NAME
}
